export class FileUpload {
    name: string;
    size: number;
    type: string;
    lastModified: number;
    base64?: string;
}
